export const API_MIN_CHARS = 3;
